import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircleIcon, DownloadIcon, MailIcon, CalendarIcon, ClockIcon, MapPinIcon, BedIcon, PlaneIcon, UserIcon, PhoneIcon, ShareIcon, PrinterIcon } from 'lucide-react';
import Button from '../components/common/Button';
const Confirmation = () => {
  const location = useLocation();
  // Generate a random booking reference
  const bookingReference = `TRV-${Math.floor(100000000 + Math.random() * 900000000)}`;
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-880">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-881">
        <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-882">
          <div className="text-center mb-8" data-id="element-883">
            <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4" data-id="element-884">
              <CheckCircleIcon className="h-10 w-10 text-green-600" data-id="element-885" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-886">
              Booking Confirmed!
            </h1>
            <p className="mt-2 text-gray-600" data-id="element-887">
              Your booking has been successfully completed.
            </p>
            <div className="mt-4 inline-block bg-blue-50 rounded-full px-4 py-2 text-sm font-medium text-blue-700" data-id="element-888">
              Booking Reference: {bookingReference}
            </div>
          </div>
          <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-889">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6" data-id="element-890">
              <h2 className="text-lg font-medium text-gray-900 mb-2 md:mb-0" data-id="element-891">
                Booking Details
              </h2>
              <div className="flex space-x-2" data-id="element-892">
                <Button variant="outline" size="sm" className="flex items-center" data-id="element-893">
                  <PrinterIcon className="h-4 w-4 mr-1" data-id="element-894" />
                  Print
                </Button>
                <Button variant="outline" size="sm" className="flex items-center" data-id="element-895">
                  <MailIcon className="h-4 w-4 mr-1" data-id="element-896" />
                  Email
                </Button>
                <Button variant="outline" size="sm" className="flex items-center" data-id="element-897">
                  <ShareIcon className="h-4 w-4 mr-1" data-id="element-898" />
                  Share
                </Button>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-899">
              <div data-id="element-900">
                <div className="bg-gray-50 rounded-lg p-4 mb-6" data-id="element-901">
                  <div className="flex items-center mb-3" data-id="element-902">
                    <UserIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-903" />
                    <h3 className="font-medium text-gray-900" data-id="element-904">
                      Traveler Information
                    </h3>
                  </div>
                  <div className="text-sm text-gray-600 space-y-2" data-id="element-905">
                    <p data-id="element-906">John Smith</p>
                    <div className="flex items-center" data-id="element-907">
                      <MailIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-908" />
                      <span data-id="element-909">john.smith@example.com</span>
                    </div>
                    <div className="flex items-center" data-id="element-910">
                      <PhoneIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-911" />
                      <span data-id="element-912">+1 (555) 123-4567</span>
                    </div>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-lg p-4 mb-6" data-id="element-913">
                  <div className="flex items-center mb-3" data-id="element-914">
                    <PlaneIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-915" />
                    <h3 className="font-medium text-gray-900" data-id="element-916">
                      Flight Details
                    </h3>
                  </div>
                  <div className="text-sm text-gray-600 space-y-2" data-id="element-917">
                    <div className="flex justify-between" data-id="element-918">
                      <span className="font-medium" data-id="element-919">
                        American Airlines AA123
                      </span>
                      <span className="text-blue-600 font-medium" data-id="element-920">
                        Confirmed
                      </span>
                    </div>
                    <p data-id="element-921">New York (JFK) to Los Angeles (LAX)</p>
                    <div className="flex items-center" data-id="element-922">
                      <CalendarIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-923" />
                      <span data-id="element-924">August 15, 2023</span>
                    </div>
                    <div className="flex items-center" data-id="element-925">
                      <ClockIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-926" />
                      <span data-id="element-927">Departure: 8:30 AM • Arrival: 11:45 AM</span>
                    </div>
                    <p className="text-gray-500 mt-2" data-id="element-928">
                      E-ticket has been sent to your email.
                    </p>
                    <div className="mt-4" data-id="element-929">
                      <Button variant="outline" size="sm" className="flex items-center" data-id="element-930">
                        <DownloadIcon className="h-4 w-4 mr-1" data-id="element-931" />
                        Download E-Ticket
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-932">
                <div className="border border-gray-200 rounded-lg p-4 mb-6" data-id="element-933">
                  <div className="flex items-center mb-3" data-id="element-934">
                    <BedIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-935" />
                    <h3 className="font-medium text-gray-900" data-id="element-936">Hotel Details</h3>
                  </div>
                  <div className="text-sm text-gray-600 space-y-2" data-id="element-937">
                    <div className="flex justify-between" data-id="element-938">
                      <span className="font-medium" data-id="element-939">Grand Luxury Resort</span>
                      <span className="text-blue-600 font-medium" data-id="element-940">
                        Confirmed
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-941">
                      <MapPinIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-942" />
                      <span data-id="element-943">123 Beach Avenue, Los Angeles, USA</span>
                    </div>
                    <div className="flex items-center" data-id="element-944">
                      <CalendarIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-945" />
                      <span data-id="element-946">
                        Check-in: Aug 15, 2023 • Check-out: Aug 22, 2023
                      </span>
                    </div>
                    <p data-id="element-947">Room: Deluxe Double Room</p>
                    <p data-id="element-948">Guests: 2 Adults</p>
                    <p className="text-gray-500 mt-2" data-id="element-949">
                      Hotel voucher has been sent to your email.
                    </p>
                    <div className="mt-4" data-id="element-950">
                      <Button variant="outline" size="sm" className="flex items-center" data-id="element-951">
                        <DownloadIcon className="h-4 w-4 mr-1" data-id="element-952" />
                        Download Hotel Voucher
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-lg p-4" data-id="element-953">
                  <h3 className="font-medium text-gray-900 mb-3" data-id="element-954">
                    Payment Summary
                  </h3>
                  <div className="text-sm space-y-2" data-id="element-955">
                    <div className="flex justify-between" data-id="element-956">
                      <span className="text-gray-600" data-id="element-957">Flight</span>
                      <span className="text-gray-900" data-id="element-958">$349.00</span>
                    </div>
                    <div className="flex justify-between" data-id="element-959">
                      <span className="text-gray-600" data-id="element-960">Hotel (7 nights)</span>
                      <span className="text-gray-900" data-id="element-961">$2,093.00</span>
                    </div>
                    <div className="flex justify-between" data-id="element-962">
                      <span className="text-gray-600" data-id="element-963">Package Savings</span>
                      <span className="text-green-600" data-id="element-964">-$250.00</span>
                    </div>
                    <div className="flex justify-between" data-id="element-965">
                      <span className="text-gray-600" data-id="element-966">Taxes & Fees</span>
                      <span className="text-gray-900" data-id="element-967">$120.00</span>
                    </div>
                    <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-968">
                      <div className="flex justify-between font-medium" data-id="element-969">
                        <span data-id="element-970">Total Paid</span>
                        <span className="text-blue-600" data-id="element-971">$2,312.00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-972">
            <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-973">
              What's Next?
            </h2>
            <div className="bg-blue-50 rounded-lg p-4 mb-6" data-id="element-974">
              <div className="flex" data-id="element-975">
                <div className="flex-shrink-0" data-id="element-976">
                  <CalendarIcon className="h-5 w-5 text-blue-600" data-id="element-977" />
                </div>
                <div className="ml-3" data-id="element-978">
                  <h3 className="text-sm font-medium text-blue-800" data-id="element-979">
                    Important Travel Information
                  </h3>
                  <div className="mt-2 text-sm text-blue-700" data-id="element-980">
                    <ul className="list-disc pl-5 space-y-1" data-id="element-981">
                      <li data-id="element-982">
                        Please arrive at the airport at least 2 hours before
                        your flight.
                      </li>
                      <li data-id="element-983">Don't forget to bring your valid ID or passport.</li>
                      <li data-id="element-984">
                        Hotel check-in time is 3:00 PM and check-out time is
                        11:00 AM.
                      </li>
                      <li data-id="element-985">
                        You can manage your booking anytime from your account.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-986">
              A confirmation email has been sent to your email address. You can
              also access your booking anytime in your account.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-987">
            <Link to="/account" data-id="element-988">
              <Button variant="outline" data-id="element-989">View My Bookings</Button>
            </Link>
            <Link to="/" data-id="element-990">
              <Button variant="primary" data-id="element-991">Back to Home</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default Confirmation;